import { generateUniqueId } from '@acre/utils'

export const getPredictedRevenueFromMortgage = (
  caseId: string,
  mortgages?: Partial<Mortgage>[],
): PredictedRevenueEntry | null => {
  const selectedMortgages = getSelectedMortgages(mortgages)
  const selectedMortgagesForCase = selectedMortgages?.filter((mortgage) => mortgage.case_ids?.includes(caseId))
  const { procFee, lenderNames } = sumUpMortgagesProcFees(selectedMortgagesForCase) || {}
  if (procFee) {
    return {
      id: generateUniqueId(),
      fee_type: 'mortgageProcFee',
      value: procFee,
      payer: lenderNames?.join(', '),
      frequency: null,
      commission: null,
      commission_period: null,
    }
  }
  return null
}

export const getSelectedMortgages = (mortgages?: Partial<Mortgage>[]) =>
  mortgages?.filter(({ status }) => status === 'STATUS_SELECTED')

export const sumUpMortgagesProcFees = (mortgages?: Partial<Mortgage>[]) => {
  return mortgages?.reduce(
    (acc, mortgage) => {
      const netProcfee = Number(mortgage?.calculated_values?.calculated_net_proc_fee)
      if (netProcfee && !isNaN(netProcfee)) {
        acc.procFee += netProcfee

        if (mortgage.mortgage_product?.lender_name) {
          acc.lenderNames.push(mortgage.mortgage_product?.lender_name)
        }
      }
      return acc
    },
    {
      procFee: 0,
      lenderNames: [],
    } as {
      procFee: number
      lenderNames: string[]
    },
  )
}
